import "./Hero.scss";

function Hero(props) {
  return (
    <section className="hero">
      <div className="hero__wrapper">
        <section>
          <video className="hero__video" poster={props.poster} controls></video>
        </section>
      </div>
    </section>
  );
}

export default Hero;
